<div class="card main-store-card container-fluid">
  <p-confirmDialog />
  
  <!-- Header: Titulo y Botón Volver -->
  <div class="row justify-content-between align-items-center mb-4">
    <div class="col-auto">
      <h3 class="m-0 font-bold text-muted">Administración de Negocio</h3>
    </div>
    <div class="col-auto">
      <p-button
        label="Volver"
        icon="pi pi-arrow-left"
        routerLink="/admin/store"
        severity="secondary"
        [rounded]="true"
        size="small"
      />
    </div>
  </div>

  @if (storeInfo) {
    <!-- Banner Principal -->
    <div class="store-banner"></div>

    <!-- Perfil Superpuesto -->
    <div class="store-profile-header">
      <div class="logo-container">
        @if (storeInfo.sto_logo_url) {
          <img src="{{ storeInfo.sto_logo_url }}" alt="Logo" class="store-logo-img" />
        } @else {
          <div class="store-logo-placeholder">
            {{ storeInfo.sto_name.slice(0, 2) }}
          </div>
        }
      </div>
      
      <div class="store-meta-info">
        <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
          <h2 class="store-title m-0">{{ storeInfo.sto_name }}</h2>
          <span class="status-badge" [ngClass]="selectedStatus?.sst_id === 1 ? 'status-open' : 'status-closed'">
            {{ selectedStatus?.sst_name || 'Desconocido' }}
          </span>
        </div>
        <p class="store-description m-0">{{ storeInfo.sto_description || 'Sin descripción disponible' }}</p>
      </div>
    </div>

    <!-- Tabs del Sistema -->
    <p-tabView class="mt-4">
      <p-tabPanel header="Información General">
        <div class="container-fluid p-0 mt-3">
          <div class="row">
            
            <!-- Columna Izquierda: Información Detallada y Horarios -->
            <div class="col-lg-8 mb-4">
              
              <!-- Tarjeta: Información Básica -->
              <div class="detail-card">
                <div class="detail-card-title">
                  <i class="pi pi-info-circle"></i> Información Básica y de Contacto
                </div>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-blue">
                        <i class="pi pi-phone"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Teléfono del Negocio</div>
                        <p class="info-value">{{ storeInfo.sto_phone || 'Sin teléfono' }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-purple">
                        <i class="pi pi-align-left"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Descripción Comercial</div>
                        <p class="info-value text-muted">{{ storeInfo.sto_description || 'Sin descripción asignada' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tarjeta: Ubicación y Datos Comerciales -->
              <div class="detail-card">
                <div class="detail-card-title">
                  <i class="pi pi-map-marker"></i> Ubicación y Parámetros Comerciales
                </div>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-orange">
                        <i class="pi pi-compass"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Dirección</div>
                        <p class="info-value font-bold">{{ storeInfo.sto_address || 'Sin dirección asignada' }}</p>
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-blue">
                        <i class="pi pi-map"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Radio de Entrega</div>
                        <p class="info-value">{{ storeInfo.sto_delivery_radius_km }} km</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-green">
                        <i class="pi pi-money-bill"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Tarifa de Envío</div>
                        <p class="info-value">${{ storeInfo.sto_delivery_fee }}</p>
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-purple">
                        <i class="pi pi-shopping-bag"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Monto de Pedido Mínimo</div>
                        <p class="info-value">${{ storeInfo.sto_min_order_amount }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- Coordenadas -->
                <div class="row mt-3 pt-3 border-top">
                  <div class="col-sm-6 mb-2">
                    <span class="info-label">Latitud</span>
                    <div class="mt-1 d-flex align-items-center gap-2">
                      <i class="pi pi-compass text-muted"></i>
                      <code>{{ storeInfo.sto_lat }}</code>
                    </div>
                  </div>
                  <div class="col-sm-6 mb-2">
                    <span class="info-label">Longitud</span>
                    <div class="mt-1 d-flex align-items-center gap-2">
                      <i class="pi pi-compass text-muted"></i>
                      <code>{{ storeInfo.sto_lng }}</code>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tarjeta: Horarios de Funcionamiento -->
              <div class="detail-card">
                <div class="detail-card-title mb-3">
                  <i class="pi pi-clock"></i> Horarios de Funcionamiento
                </div>
                @if (storeInfo.schedules && storeInfo.schedules.length > 0) {
                  <p-table [value]="storeInfo.schedules" styleClass="p-datatable-sm p-datatable-striped">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Día</th>
                        <th>Estado</th>
                        <th>Hora Apertura</th>
                        <th>Hora Cierre</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-schedule>
                      <tr>
                        <td class="font-bold">{{ getDayName(schedule.ssh_day_of_week) }}</td>
                        <td>
                          <span class="status-badge" [ngClass]="schedule.ssh_is_open ? 'status-open' : 'status-closed'">
                            {{ schedule.ssh_is_open ? 'Abierto' : 'Cerrado' }}
                          </span>
                        </td>
                        <td>
                          <i class="pi pi-clock text-muted mr-1"></i> {{ schedule.ssh_open_time }}
                        </td>
                        <td>
                          <i class="pi pi-clock text-muted mr-1"></i> {{ schedule.ssh_close_time }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                } @else {
                  <div class="text-center py-4 text-muted">
                    <i class="pi pi-calendar-times d-block mb-2" style="font-size: 2.5rem; color: var(--text-color-secondary);"></i>
                    <p class="m-0">Sin horarios configurados en este negocio</p>
                  </div>
                }
              </div>
            </div>

            <!-- Columna Derecha: Control de Estado y Acciones -->
            <div class="col-lg-4 mb-4">
              
              <!-- Tarjeta de Estado actual -->
              <div class="detail-card">
                <div class="detail-card-title">
                  <i class="pi pi-sliders-h"></i> Gestión de Estado
                </div>
                <div class="status-action-box">
                  <div class="status-label-indicator">
                    <span class="text-muted">Estado Actual:</span>
                    <span class="status-badge" [ngClass]="selectedStatus?.sst_id === 1 ? 'status-open' : 'status-closed'">
                      {{ selectedStatus?.sst_name || 'Desconocido' }}
                    </span>
                  </div>
                  
                  <div class="mb-3">
                    <label class="info-label d-block mb-2">Cambiar Estado</label>
                    <p-dropdown
                      [options]="ltsStoreStatus"
                      [(ngModel)]="selectedStatus"
                      optionLabel="sst_name"
                      placeholder="Selecciona un estado"
                      styleClass="w-100"
                    />
                  </div>
                  
                  <p-button
                    label="Actualizar Estado"
                    icon="pi pi-check"
                    styleClass="w-100 p-button-primary mt-2"
                    [loading]="loading"
                    (onClick)="changeStatus($event)"
                    (keydown.enter)="changeStatus($event)"
                  />
                </div>
              </div>

              <!-- Tarjeta: Destacado actual -->
              <div class="detail-card">
                <div class="detail-card-title">
                  <i class="pi pi-star"></i> Gestión de Destacado
                </div>
                <div class="status-action-box">
                  <div class="mb-3">
                    <label class="info-label d-block mb-2">Negocio Destacado</label>
                    <p-toggleButton
                      [(ngModel)]="pendingFeatured"
                      onLabel="Sí"
                      offLabel="No"
                      styleClass="w-100"
                    />
                  </div>

                  <p-button
                    label="Actualizar Destacado"
                    icon="pi pi-check"
                    styleClass="w-100 p-button-primary mt-2"
                    [loading]="loading"
                    (onClick)="changeFeatured($event)"
                    (keydown.enter)="changeFeatured($event)"
                  />
                </div>
              </div>

              <!-- Tarjeta: Acciones Rápidas -->
              <div class="detail-card">
                <div class="detail-card-title">
                  <i class="pi pi-cog"></i> Panel de Control
                </div>
                <p class="text-muted small mb-3">Realiza modificaciones generales o ajustes en la configuración del negocio.</p>
                <p-button
                  label="Editar Información"
                  icon="pi pi-pencil"
                  [routerLink]="'/admin/store/edit/' + storeInfo.sto_id"
                  styleClass="w-100 p-button-info"
                  [rounded]="true"
                />
              </div>

            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Productos">
        <div class="mt-3">
          <app-list-product [storeId]="storeInfo.sto_id" />
        </div>
      </p-tabPanel>
    </p-tabView>
  } @else {
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
      <i class="pi pi-spin pi-spinner text-primary mb-3" style="font-size: 3rem"></i>
      <p class="text-muted font-bold">Cargando información del negocio...</p>
    </div>
  }
</div>
